import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  editProfile: {
    marginTop: 70,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
  },
  container: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space20}px`,
  },
  userName: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
  },
  btn: {
    position: "absolute !important",
    bottom: 32,
    margin: `0 ${theme.spacing.space20}px`,
    width: "calc(100% - 40px) !important",
  },
}));
